module.exports = __webpack_public_path__ + "static/media/s6.38293ac2.jpg";